var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container summary__background"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"cs-textstyle-item-heading"},[_vm._v(" Bucket+ makes it easy to add powerful capabilities to any storage bucket from any cloud provider. This accelerates innovation, and reduces TCO. ")])])])
}]

export { render, staticRenderFns }